// extracted by mini-css-extract-plugin
module.exports = {"bodywrapper":"signin_bodywrapper__2bQAf","logo":"signin_logo__IhsAp","pagetitle":"signin_pagetitle__2Mgx4"};